import { Print } from "@mui/icons-material";
import { Button, ListItemIcon, MenuItem } from "@mui/material";
import { labelButtonStyle } from "../../../../components/shared/PopupMenu";
import { toastMessage } from "../../../../constants/strings";
import {
  PrintResult,
  usePrintBulkReport,
} from "../../../../hooks/react-query/usePrint";
import { useDateSearchParamOrFallbackToToday } from "../../../../hooks/useDateSearchParamOrFallbackToToday";
import { useSelectedServiceCenter } from "../../../../hooks/useSelectedServiceCenter";
import { PlanTableFormat } from "../../../../types/planning/plan.type";
import { toast } from "../../../../utils/snackbarHelper";
import { useActionsMenuContext } from "../../shared/ActionsMenuContext";

type PrintMenuItemProps = {
  routesOrTraps: PlanTableFormat[];
  handleClose?: () => void;
  clearSelection?: () => void;
  isBulkPrint: boolean;
};

export const PrintMenuItem = ({
  routesOrTraps,
  clearSelection = () => {},
  handleClose = () => {},
  isBulkPrint,
}: PrintMenuItemProps) => {
  const { openDialog } = useActionsMenuContext();
  const [serviceCenter] = useSelectedServiceCenter();
  const [selectedDate] = useDateSearchParamOrFallbackToToday();

  const onPrintSuccess = (result: PrintResult) => {
    clearSelection();
    if (result.state === "Processed") {
      window.open(result.url, "_blank");
    }
  };

  const { mutate: printBulkReport } = usePrintBulkReport(onPrintSuccess);

  const handleBulkPrintClick = () => {
    const plansWithBills = routesOrTraps.filter(
      (routeOrTrap) => routeOrTrap.bills > 0
    );

    const routes = routesOrTraps.filter(
      (record) => record.type === "delivery_route"
    );

    const traps = routesOrTraps.filter(
      (record) => record.type === "delivery_trap"
    );

    if (routes.length === 0 && traps.length === 0) {
      toast(toastMessage.inbound.print.selectAtLeastOneRoute, {
        variant: "warning",
      });
      return;
    }

    if (plansWithBills.length === 0) {
      toast(toastMessage.inbound.print.noBills, {
        variant: "warning",
      });
      return;
    }

    handleClose();
    openDialog({
      name: "print",
      planSummaries: routesOrTraps,
      clearSelection,
    });
  };

  const handlePrint = () => {
    const rowOrTrap = routesOrTraps[0];

    if (rowOrTrap.bills <= 0) {
      toast(toastMessage.inbound.print.noBills, {
        variant: "warning",
      });
      return;
    }

    handleClose();
    if (rowOrTrap.type === "delivery_trap") {
      printBulkReport({
        sicId: serviceCenter.id,
        planDate: selectedDate,
        trapLoadCard: {
          trapIds: [rowOrTrap.id],
        },
      });
    } else {
      openDialog({ name: "print", planSummaries: [rowOrTrap], clearSelection });
    }
  };

  return (
    <MenuItem onClick={isBulkPrint ? handleBulkPrintClick : handlePrint}>
      <ListItemIcon>
        <Print />
      </ListItemIcon>
      <Button sx={labelButtonStyle} disableRipple>
        Print
      </Button>
    </MenuItem>
  );
};
